module.exports = new __parcel__URL__("bird02.dc902f41.mp3").toString();